import { getErrorMessage, getErrorId } from '../constants/error.messages';
import { SHOW_ERR_MSG } from './common/actionTypes';
import { SHOW_ERR_MSG as SHOW_LOGGED_ERR } from './logged/actionTypes';
import { isObject } from '../helpers/utils';

export const actionMidlewares = (store) => (next) => (action) => {
  if (action.type === SHOW_ERR_MSG || action.type === SHOW_LOGGED_ERR) {
    try {
      let messageFinal = action.payload.message;
      const { message, ...props } = action.payload;
      if (isObject(messageFinal)) {
        messageFinal = messageFinal.message;
        if (isObject(messageFinal)) {
          messageFinal = messageFinal.message;
        }
      }
      action.payload = {
        title: getErrorMessage(messageFinal),
        analyticsId: getErrorId(messageFinal),
        ...props,
      };
    } catch (e) {
      action.payload = { title: getErrorMessage('error') };
    }
  }
  return next(action);
};
